const channelName = 'notas-local-sync';
const storageKey = 'notas-local-sync-ping';
let channel = null;

function getChannel() {
  if (typeof window === 'undefined' || typeof BroadcastChannel === 'undefined') return null;
  if (!channel) channel = new BroadcastChannel(channelName);
  return channel;
}

function emitStoragePing(payload = {}) {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(storageKey, JSON.stringify({ ...payload, at: Date.now() }));
  } catch (error) {
    // Safari privado o storage bloqueado.
  }
}

export function publishLocalChange(payload = {}) {
  const message = { ...payload, at: Date.now() };
  const instance = getChannel();
  if (instance) {
    instance.postMessage(message);
  }
  emitStoragePing(message);
}

export function subscribeLocalChanges(handler) {
  const instance = getChannel();
  const listeners = [];

  if (instance) {
    const channelListener = (event) => handler(event.data || {});
    instance.addEventListener('message', channelListener);
    listeners.push(() => instance.removeEventListener('message', channelListener));
  }

  if (typeof window !== 'undefined') {
    const storageListener = (event) => {
      if (event.key !== storageKey || !event.newValue) return;
      try {
        handler(JSON.parse(event.newValue) || {});
      } catch (error) {
        handler({ type: 'local-refresh', at: Date.now() });
      }
    };
    window.addEventListener('storage', storageListener);
    listeners.push(() => window.removeEventListener('storage', storageListener));
  }

  return () => listeners.forEach((off) => off());
}
